import * as React from 'react';

import Task16 from './Task16';

export const task16 = () => <Task16 />;

export default {
    title: 'Icon/Fill/Task16',
    component: Task16,
    parameters: {
        notes: "`import Task16 from 'box-ui-elements/es/icon/fill/Task16';`",
    },
};
